import React from "react";
import s from "./style.module.css";
import ContactForm from "./contactForm/ContactForm";
import { FaPhone } from "react-icons/fa6";

export default function Contact() {
  return (
    <>
      <div className={`row p-0 m-0 ${s.relative}`}>
        <img className={`${s.croix1}`} src="/assets/croix.webp" alt="croix" />
        <img className={`${s.croix2}`} src="/assets/croix.webp" alt="croix" />
      </div>
      <div className={`col-12 ${s.miniBoxImg}`}>
        <div className={`${s.title}`}>
          <span className={s.noWrap}>UNE QUESTION ?</span>
          {""} <span className={s.noWrap}>UN BESOIN ?</span>
        </div>
        <div className={`${s.subTitle}`}>
          Je serai ravi d'en discuter{" "}
          <span className={s.noWrap}>avec vous !</span>
        </div>
        <div className="d-flex align-items-center">
          <FaPhone className={`${s.telIcon}`} />{" "}
          <div className={`${s.tel}`}>06 52 03 33 00</div>
        </div>
      </div>
      <div className={`col-12 col-lg-6 ${s.miniBox}`}>
        <img className={`${s.me}`} src="/assets/meContact.webp" alt="me" />
      </div>
      <div className={`pb-5 col-12 col-lg-6 ${s.miniBox} ${s.miniBoxForm}`}>
        <ContactForm />
      </div>
    </>
  );
}
